import { useState, useEffect } from "react";
import ScholarDataService from "../services/ScholarService";
import DeleteIcon from '@material-ui/icons/Delete';
import axios from 'axios';
import { formatDateTime } from './Utils.js';

export default function Scholar( props ) {
  
  const initialScholarState = {
    key: null,
    iskoNumber: 0,
    nickname: "",
    ethereumAddress: "",
    dailyAvg: "",
    totalSlp: 0,
    claimable: 0,
    lastClaimed: "",
    claimableOn: "",
    totalDaysPlayed: "",
    rank: "",
    mmr: "",
    roninAddress: ""
  };
  const [currentScholar, setCurrentScholar] = useState(initialScholarState);
  const { scholar } = props;

  if (currentScholar.id !== scholar.id) {
    setCurrentScholar(scholar);
  }

  useEffect(() => {
    async function getBasicAxieData (){
      axios.get(`https://game-api.skymavis.com/game-api/clients/${scholar.ethereumAddress}/items/1`).then(resp => {
          let lastClaimedItemAt = formatDateTime(resp.data.last_claimed_item_at*1000);
          const dtDiff = new Date().getTime() - new Date(lastClaimedItemAt).getTime();
          var totalDays = parseInt(dtDiff / (1000 * 3600 * 24) );
          var dailyAvg = Math.round(resp.data.total/totalDays).toString();
  
          var dtClaimableOn=new Date(lastClaimedItemAt);
          dtClaimableOn.setDate(dtClaimableOn.getDate()+ 14); 
          var descriptionClaimableOn = formatDateTime(dtClaimableOn);
          if(new Date().getTime() > new Date(descriptionClaimableOn).getTime() ){
            descriptionClaimableOn = "CLAIMABLE";
          }
          console.log("resp",resp.data);
          /*
           * Set Current Scholar State 
           */
          setCurrentScholar({ ...currentScholar, 
            dailyAvg: dailyAvg,
            totalDaysPlayed: totalDays,
            totalSlp: resp.data.total, 
            claimable: resp.data.total - resp.data.claimable_total, 
            lastClaimed: lastClaimedItemAt,
            claimableOn: descriptionClaimableOn
          });  
          getBasicStats();
      })      
    }
    
    async function getBasicStats (){
      try{
        await axios.get(`https://game-api.axie.technology/api/v1/${currentScholar.ethereumAddress}`).then(resp => {
          // if(resp.status === 200){
          //   if(resp.data.slp_success){
          //     setCurrentScholar(prevState => ({  
          //       ...prevState,  
          //       mmr: resp.data.mmr,
          //       rank: resp.data.rank
          //     }) );
          //   }
          // }
          if(resp.status === 200){
            setCurrentScholar(prevState => ({  
              ...prevState,  
              mmr: resp.data.mmr,
              rank: resp.data.rank
            }) );
          }
        })
      } catch (e) {
      }
    }

    if(scholar !== ''){
      // if (currentScholar.id !== scholar.id) {
        getBasicAxieData();
      // }
    }

  }, [scholar]);
  
  function handleChange(currentScholar) {
    props.sendToScholars(currentScholar);
  }
  
  useEffect(() => {
    handleChange(currentScholar);
  }, [currentScholar]);

  const deleteScholar = (id) => {
    ScholarDataService.remove(id)
      .then(() => {
        // props.refreshList();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <tr className={`table-light ${currentScholar.nickname.toUpperCase() == "INACTIVE" ? "inactive" : ""}`} key={scholar.id}>
        <td>
          <a href={`https://marketplace.axieinfinity.com/profile/${currentScholar.ethereumAddress}/axie`} target="_blank">{currentScholar.iskoNumber == 0 ? currentScholar.iskoNumber + " - " + `${currentScholar.nickname}` : "Isko - " + currentScholar.iskoNumber + " - " + `${currentScholar.nickname}`}</a>
        </td>
        <td className={currentScholar.mmr < 1000 ? "c-red" : ""}>{currentScholar.mmr}</td>
        <td className={currentScholar.dailyAvg < 100 ? "c-red" : ""}>{currentScholar.dailyAvg} ({currentScholar.totalDaysPlayed}D)</td>
        <td className={currentScholar.nickname == "Inactive" ? "c-red" : ""}>{currentScholar.claimable}</td>
        <td>{currentScholar.totalSlp}</td>
        <td className={currentScholar.claimableOn == "CLAIMABLE" ? "c-green" : ""}>{currentScholar.claimableOn}</td>
        <td>
          <div className="remove">
            <a href="#" onClick={() => deleteScholar(scholar.id)}><DeleteIcon /></a>
          </div>          
        </td>
    </tr>
  );
}
